/* mm-creator.js — die Creator-Videos im Kartenbild, das Mert gezeigt hat.
 *
 * 23.08.2026, Mert mit zwei Bildern: "ich will diesen design ohne fehler 1zu1
 * hier in der section". Gezeigt war eine dunkle, abgerundete Karte mit
 * Videobild, grossem runden Abspielknopf, Creator-Name mit Haken darunter
 * "@name . 55K+ Follower" und einem pinken "ZUM VIDEO".
 *
 * Ersetzt wird die Ansicht des Sternify-Bausteins "st_shoppable_slider". Der
 * Baustein selbst bleibt im Theme (nur ausgeblendet) - seine Videos, Namen und
 * Produktverweise werden von hier ausgelesen. Aendert Mert dort etwas, kommt es
 * hier automatisch mit; es gibt keine zweite Datenpflege.
 *
 * Was an der alten Ansicht kaputt war (Bild 2): die Karten an den Raendern waren
 * angeschnitten, die Pfeile lagen ueber den Karten, und die Schrift sprang von
 * Karte zu Karte. Deshalb:
 *   - keine Pfeile mehr (Wischen am Handy, Raster am Rechner),
 *   - ganze Karten statt angeschnittener,
 *   - das Videobild liegt vollstaendig in der Flaeche (contain, gleiches
 *     Seitenverhaeltnis) - in den Videos steht Text, der darf nie beschnitten
 *     werden,
 *   - eine einzige Schrift fuer alles.
 *
 * ANMERKUNG zur Regel "kein pinker Text auf Dunkel": Mert hat das pinke
 * "ZUM VIDEO" ausdruecklich so vorgegeben und "1zu1" verlangt. Es bleibt die
 * einzige pinke Schrift auf der Seite.
 */
(function () {
  'use strict';

  var QUELLE = '[id*="st_shoppable_slider"]';

  /* 23.08.2026, Mert: "raus mit dem video". Gemeint war das "Finale
     Liefer-Update" - eine alte Versandmeldung mit gelben Postkisten, die
     zwischen den Creator-Videos stand. Sie bleibt im Sternify-Baustein
     erhalten (dort pflegt Mert sie), wird hier aber nicht mehr gezeigt.
     Erkannt wird sie an der Kennung der Datei, nicht an der Position. */
  var NICHT = ['416dbb71b93e4402b191fb3c187f2724'];

  var css = [
    '#mmCre{background:#151013;color:#F3E9EC;padding:52px 0 58px;box-sizing:border-box}',
    '#mmCre *{box-sizing:border-box}',
    '#mmCreKopf{max-width:900px;margin:0 auto 26px;padding:0 20px;text-align:center}',
    '#mmCre h2{font-family:"MM Poppins","DM Sans",sans-serif;font-weight:900;',
    'font-size:clamp(1.7rem,6.2vw,2.7rem);line-height:1.06;margin:0 0 10px;',
    'letter-spacing:-.01em;text-transform:uppercase}',
    '#mmCreVor{margin:0;font-size:.98rem;line-height:1.55;',
    'color:rgba(243,233,236,.66)}',

    /* Handy: wischen, eine Karte fuellt die Breite, die naechste lugt hervor.
       Rechner: festes Raster mit gedeckelter Kartenbreite - feste Regel
       "auf PC niemals so gross". */
    '#mmCreReihe{display:flex;gap:14px;overflow-x:auto;scroll-snap-type:x mandatory;',
    'padding:4px 20px 18px;-webkit-overflow-scrolling:touch;scrollbar-width:none}',
    '#mmCreReihe::-webkit-scrollbar{display:none}',
    /* 29.08.2026, Mert zweimal: "zu gross etwas kleiner machen ... nimmt zu viel
       platz". GERECHNET: 74vw waren am Handy (390 px) 289 px breit, bei 9:16
       also 514 px hohes Video plus Fusszeile - eine Karte fuellte fast den
       ganzen Bildschirm. 58vw sind 226 px und 402 px Video, rund ein Fuenftel
       weniger Hoehe. Dass ein Stueck der naechsten Karte hereinschaut, bleibt
       so - daran erkennt man, dass man wischen kann. */
    '.mmCreKarte{flex:0 0 58vw;max-width:230px;scroll-snap-align:center}',
    /* 23.08.2026 GEMESSEN: Als Raster wurde die Sektion am Rechner 2.637 px hoch
       (13 Karten in vier Reihen). Mert hat eine Reihe gezeigt, keine Wand.
       Also bleibt es auch am Rechner eine Reihe zum Wischen - ohne Pfeile,
       damit nichts mehr ueber den Karten liegt. */
    '@media(min-width:760px){',
    '#mmCreReihe{max-width:1180px;margin:0 auto;gap:18px;padding:4px 20px 22px}',
    '.mmCreKarte{flex:0 0 210px;max-width:210px}}',

    '.mmCreKarte{background:#1E1519;border:1px solid rgba(243,233,236,.10);',
    'border-radius:22px;overflow:hidden;display:flex;flex-direction:column}',

    /* 9:16 - genau das Format der Videos. Mit `contain` kann nichts abgeschnitten
       werden, auch wenn ein Video einmal anders geschnitten ist. */
    '.mmCreBild{position:relative;aspect-ratio:9/16;background:#0E0A0C;',
    'display:block;width:100%;border:0;padding:0;cursor:pointer}',
    '.mmCreBild img,.mmCreBild video{width:100%;height:100%;object-fit:contain;',
    'display:block}',
    '.mmCrePlay{position:absolute;inset:0;display:grid;place-items:center;',
    'pointer-events:none}',
    '.mmCrePlay span{width:54px;height:54px;border-radius:50%;',
    'border:2px solid rgba(255,255,255,.85);background:rgba(255,255,255,.14);',
    '-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);',
    'display:grid;place-items:center;transition:transform .25s ease}',
    '@media(hover:hover){.mmCreBild:hover .mmCrePlay span{transform:scale(1.08)}}',
    '.mmCrePlay svg{width:19px;height:19px;margin-left:3px;fill:#FFFFFF}',
    '.mmCreKarte.laeuft .mmCrePlay{display:none}',

    '.mmCreFuss{padding:16px 18px 18px}',
    '.mmCreName{display:flex;align-items:center;gap:7px;',
    'font-family:"MM Poppins","DM Sans",sans-serif;font-weight:800;',
    'font-size:1.12rem;line-height:1.2;margin:0}',
    '.mmCreHaken{width:17px;height:17px;flex:0 0 auto}',
    '.mmCreMeta{margin:6px 0 0;font-size:.9rem;line-height:1.35;',
    'color:rgba(243,233,236,.62)}',
    '.mmCreMeta b{color:#F3E9EC;font-weight:700}',
    '.mmCreZum{position:relative;display:inline-flex;align-items:center;gap:7px;margin:14px 0 0;',
    'font-size:.9rem;font-weight:800;letter-spacing:.06em;text-transform:uppercase;',
    'color:#FF7188;background:none;border:0;padding:0 0 4px;cursor:pointer;',
    'font-family:inherit;opacity:0;transform:translateX(-8px);',
    'transition:color .22s ease,opacity .5s cubic-bezier(.22,.61,.36,1) .18s,',
    'transform .5s cubic-bezier(.22,.61,.36,1) .18s}',
    '.mmCreZum:after{content:"";position:absolute;left:0;bottom:0;width:100%;height:1px;',
    'background:currentColor;transform:scaleX(0);transform-origin:left center;',
    'transition:transform .28s cubic-bezier(.22,.61,.36,1)}',
    '.mmCreKarte.mmCreRein .mmCreZum,.mmCreKarte.fertig .mmCreZum{opacity:1;transform:none}',
    '.mmCreZum:hover,.mmCreZum:focus-visible{color:#FF91A1}',
    '.mmCreZum:hover:after,.mmCreZum:focus-visible:after{transform:scaleX(1)}',
    '.mmCreZum svg{width:11px;height:11px;fill:currentColor;transition:transform .25s cubic-bezier(.22,.61,.36,1)}',
    '.mmCreZum:hover svg,.mmCreZum:focus-visible svg{transform:translateX(3px)}',
    '.mmCreWare{display:none;margin:12px 0 0;font-size:.86rem;font-weight:700;',
    'color:#151013;background:#F3E9EC;border-radius:10px;padding:9px 14px;',
    'text-decoration:none;text-align:center}',
    '.mmCreKarte.laeuft .mmCreWare{display:block}',
    '.mmCreKarte.laeuft .mmCreZum{display:none}',

    /* Hereinkommen erst beim Hinsehen - feste Regel vom 23.08.2026. */
    '.mmCreKarte.mmCreWartet{opacity:0}',
    '.mmCreKarte.mmCreRein{animation:mmCreRein .55s cubic-bezier(.34,1.4,.5,1) ',
    'var(--mmCreV,0ms) both}',
    '@keyframes mmCreRein{0%{opacity:0;transform:translateY(20px) scale(.97)}',
    '100%{opacity:1;transform:none}}',
    /* Sicherung: Wird die Animation angehalten (Sektion aus dem Bild, Fenster
       im Hintergrund), bliebe die Karte bei opacity 0 stehen - unsichtbar.
       `fertig` schreibt den Endzustand fest, egal was die Animation macht. */
    '.mmCreKarte.fertig{opacity:1!important;animation:none!important;transform:none}',
    '@media(prefers-reduced-motion:reduce){.mmCreKarte.mmCreWartet{opacity:1}',
    '.mmCreKarte.mmCreRein{animation:none}.mmCreZum{opacity:1;transform:none;transition:none}',
    '.mmCreZum svg,.mmCreZum:after{transition:none}}'
  ].join('');

  var HAKEN = '<svg class="mmCreHaken" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path fill="#3B9DF8" d="M12 1.5l2.6 2.2 3.4-.3.6 3.4 3 1.7-1.5 3.1 1.5 3.1-3 1.7' +
    '-.6 3.4-3.4-.3L12 22.5l-2.6-2.2-3.4.3-.6-3.4-3-1.7L3.9 12 2.4 8.9l3-1.7.6-3.4' +
    ' 3.4.3z"/><path fill="#fff" d="M10.7 15.6 7.4 12.3l1.3-1.3 2 2 4.6-4.6 1.3 1.3z"/></svg>';
  var DREIECK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1l8 5-8 5z"/></svg>';
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3l15 9L6 21z"/></svg>';

  function stil() {
    if (document.getElementById('mm-creator-stil')) return;
    var s = document.createElement('style');
    s.id = 'mm-creator-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  function sauber(t) {
    /* Die Namen stehen teils in mathematischen Sonderzeichen ("𝑪𝒉𝒂𝒏𝒆𝒍").
       NFKC macht daraus normale Buchstaben; Bildzeichen fliegen raus. */
    return (t || '').normalize('NFKC')
      .replace(/[←-⯿️‍]/g, '')
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      .replace(/\s+/g, ' ').trim();
  }

  function meta(zeile) {
    var t = sauber(zeile);
    var handle = t.match(/@([A-Za-z0-9._]+)/);
    var zahl = t.match(/(\d+(?:[.,]\d+)?)\s*(K|MIO|M|MILLIONEN?)\+?/i);
    var teile = [];
    if (handle) teile.push('@' + handle[1].toLowerCase());
    if (zahl) {
      var e = zahl[2].toUpperCase();
      var wie = (e === 'K') ? 'K+' : 'Mio.';
      teile.push('<b>' + zahl[1] + ' ' + wie + '</b> Follower');
    }
    if (teile.length) return teile.join(' &middot; ');
    /* Kein Handle, keine Zahl - dann die Zeile selbst. Sie steht in der App in
       Grossbuchstaben ("MAGIC MILK IM ALLTAG"); die schreien in der Karte, und
       ein blosses Kleinschreiben macht daraus "Magic milk im alltag". Deshalb
       Wort fuer Wort gross beginnen, Zahlen und kurze Fuellwoerter ausgenommen. */
    if (!t) return '';
    var klein = { 'von': 1, 'und': 1, 'im': 1, 'in': 1, 'am': 1, 'mit': 1, 'auf': 1, 'der': 1, 'die': 1, 'das': 1 };
    return t.toLowerCase().split(' ').map(function (w, i) {
      if (!w) return w;
      if (i > 0 && klein[w]) return w;
      if (/^\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function lesen() {
    var q = document.querySelector(QUELLE);
    if (!q) return null;
    var folien = [].slice.call(q.querySelectorAll('.swiper-slide'))
      .filter(function (x) { return !/duplicate/.test(x.className || ''); });
    var gesehen = {}, daten = [];
    folien.forEach(function (k) {
      var v = k.querySelector('video');
      var a = k.querySelector('a[href*="/products/"]');
      var poster = v && v.getAttribute('poster');
      var film = v && (v.getAttribute('src') ||
        (v.querySelector('source') && v.querySelector('source').getAttribute('src')));
      if (!poster && !film) return;
      var zeilen = (k.innerText || '').split('\n')
        .map(function (t) { return t.trim(); }).filter(Boolean);
      var schluessel = (film || poster);
      for (var n = 0; n < NICHT.length; n++) {
        if (schluessel.indexOf(NICHT[n]) !== -1) return;
      }
      if (gesehen[schluessel]) return;
      gesehen[schluessel] = 1;
      daten.push({
        name: sauber(zeilen[0]) || 'Creator',
        unter: meta(zeilen[1]),
        film: film || '',
        poster: poster || '',
        ware: a ? a.getAttribute('href') : ''
      });
    });
    return daten.length ? { quelle: q, daten: daten } : null;
  }

  function karte(d) {
    var el = document.createElement('article');
    el.className = 'mmCreKarte';
    el.innerHTML =
      '<button type="button" class="mmCreBild" aria-label="Video abspielen">' +
        (d.poster ? '<img src="' + d.poster + '" alt="" loading="lazy" decoding="async">' : '') +
        '<span class="mmCrePlay"><span>' + PLAY + '</span></span>' +
      '</button>' +
      '<div class="mmCreFuss">' +
        '<p class="mmCreName">' + d.name + HAKEN + '</p>' +
        (d.unter ? '<p class="mmCreMeta">' + d.unter + '</p>' : '') +
        '<button type="button" class="mmCreZum">' + DREIECK + 'Zum Video</button>' +
        (d.ware ? '<a class="mmCreWare" href="' + d.ware + '">Produkt ansehen</a>' : '') +
      '</div>';

    function abspielen() {
      if (el.classList.contains('laeuft') || !d.film) return;
      var v = document.createElement('video');
      v.src = d.film;
      v.poster = d.poster;
      v.controls = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.preload = 'auto';
      var flaeche = el.querySelector('.mmCreBild');
      flaeche.innerHTML = '';
      flaeche.appendChild(v);
      el.classList.add('laeuft');
      var pv = v.play();
      if (pv && pv.catch) pv.catch(function () {});
      /* Feste Regel vom 23.08.2026: nichts laeuft, wenn niemand hinsieht. */
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (e) {
          if (!e.some(function (x) { return x.isIntersecting; }) && !v.paused) v.pause();
        }, { threshold: 0.35 }).observe(el);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && !v.paused) v.pause();
      });
    }

    el.querySelector('.mmCreBild').addEventListener('click', abspielen);
    el.querySelector('.mmCreZum').addEventListener('click', abspielen);
    return el;
  }

  /* --- Zieht von selbst weiter ---------------------------------------------
     23.08.2026, Mert: "automatisch sliden lassen" und "und wischen koennen".
     Wischen ging schon (die Reihe ist ein Scrollbereich mit Einrastpunkten);
     dazu kommt jetzt ein ruhiger Selbstlauf: alle 4,5 s eine Karte weiter, am
     Ende zurueck an den Anfang.

     Er haelt an, sobald jemand selbst anfasst - Wischen, Mausrad, Tastatur oder
     Maus auf der Reihe -, und er laeuft nicht, waehrend ein Video spielt.
     Feste Regel vom 23.08.2026: ausserhalb des Bildes und im Hintergrund
     passiert gar nichts. */
  function selbstSchieben(reihe) {
    if (!reihe) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;

    var TAKT = 4500;
    var imBild = false, angefasst = false, uhr = null;

    function laeuftVideo() {
      var v = reihe.querySelectorAll('video');
      for (var i = 0; i < v.length; i++) { if (!v[i].paused && !v[i].ended) return true; }
      return false;
    }

    function schritt() {
      if (!imBild || angefasst || document.hidden || laeuftVideo()) return;
      var karte = reihe.querySelector('.mmCreKarte');
      if (!karte) return;
      var breite = karte.getBoundingClientRect().width + 18;
      var rest = reihe.scrollWidth - reihe.clientWidth - reihe.scrollLeft;
      if (rest < 8) reihe.scrollTo({ left: 0, behavior: 'smooth' });
      else reihe.scrollBy({ left: breite, behavior: 'smooth' });
    }

    uhr = window.setInterval(schritt, TAKT);

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (e) {
      reihe.addEventListener(e, function () { angefasst = true; }, { passive: true });
    });
    reihe.addEventListener('pointerenter', function () { angefasst = true; });
    reihe.addEventListener('pointerleave', function () { angefasst = false; });

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) {
        imBild = e.some(function (x) { return x.isIntersecting; });
      }, { threshold: 0.25 }).observe(reihe);
    } else {
      imBild = true;
    }
  }

  function aufploppen(sek) {
    var karten = [].slice.call(sek.querySelectorAll('.mmCreKarte'));
    if (!window.IntersectionObserver || !karten.length) return;
    karten.forEach(function (k) { k.classList.add('mmCreWartet'); });
    var b = new IntersectionObserver(function (e) {
      if (!e.some(function (x) { return x.isIntersecting; })) return;
      karten.forEach(function (k, i) {
        k.style.setProperty('--mmCreV', Math.min(i, 7) * 90 + 'ms');
        k.classList.remove('mmCreWartet');
        k.classList.add('mmCreRein');
        window.setTimeout(function () { k.classList.add('fertig'); },
                          700 + Math.min(i, 7) * 90);
      });
      b.disconnect();
    }, { threshold: 0.15 });
    b.observe(sek);
  }

  function bauen() {
    if (document.getElementById('mmCre')) return true;
    var q = lesen();
    if (!q) return false;

    stil();
    var s = document.createElement('section');
    s.id = 'mmCre';
    s.setAttribute('aria-label', 'Creator-Videos');
    s.innerHTML =
      '<div id="mmCreKopf">' +
        '<h2>Over 10.000+ people trust us</h2>' +
        '<p id="mmCreVor">Trusted by Creators. Loved by Customers.</p>' +
      '</div>' +
      '<div id="mmCreReihe"></div>';

    var reihe = s.querySelector('#mmCreReihe');
    q.daten.forEach(function (d) { reihe.appendChild(karte(d)); });

    q.quelle.parentNode.insertBefore(s, q.quelle);
    selbstSchieben(s.querySelector('#mmCreReihe'));
    /* Der App-Baustein bleibt im Theme, wird aber nicht mehr gezeigt. */
    q.quelle.style.setProperty('display', 'none', 'important');

    aufploppen(s);
    return true;
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 40) window.clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else {
    versuchen();
  }
  window.addEventListener('load', versuchen);
})();
